export const API_PATHS = {
    RECRUITMENT_ATTACHMENTS_UPLOAD: "api/recruitment/attachments",
    RECRUITMENT_DEPARTMENTS: "api/recruitment/departments/",
    RECRUITMENT_PROFILES: "api/recruitment/jobOpening/",
    USER: "api/user/",
    POST_RECRUITMENT_PROFILES: "api/recruitment/jobOpening",
    PASSWORD_UPDATE_PERMISSION: "api/password/update-permission",
    CANDIDATE_LIST: "api/recruitment/candidates/",
    POST_CANDIDATE: "api/recruitment/candidates",
    RECRUITMENT_APPLICATION: "api/recruitment/application/",
    RECRUITMENT_APPLICATION_UPDATE: "api/recruitment/application/",
    RECRUITMENT_APPLICATION_DELETE: "api/recruitment/application/",
    RECRUITMENT_APPLICATION_DELETE_MANY: "api/recruitment/application/deleteMany",
    RECRUITMENT_INDIVIDUAL_PANEL: "api/recruitment/panel/",
    RECRUITMENT_INDIVIDUAL_INTERVIEW: "api/recruitment/interviews/",
    RECRUITMENT_DASHBOARD: "api/recruitment/dashboard/metrics",
    RECRUITMENT_FEEDBACK: "api/recruitment/feedback/",
    POST_REFFERAL: "api/recruitment/referral",
    REFERRAL_LIST: "api/recruitment/referral/",
    RECRUITMENT_PIPELINE: "api/recruitment/jobOpening/pipeline",
    COMPANY_POLICY: '',
    FETCH_COMPANY_RESOURCE_INFO: '',
    CREATE_COMPANY_POLICY: "api/recruitment/company-policies",
    TODO_LIST: "api/todo/",
    POST_TODO: "api/todo",
    TODO_UPDATE: "api/todo/",
    TODO_DELETE: "api/todo/",
    TODO_DELETE_MANY: "api/todo/deleteMany",
    RECRUITMENT_GUIDE: "api/recruitment/recruitment-guide",
    RECRUITMENT_GUIDE_UPLOAD: "api/recruitment/recruitment-guide/upload",
    RECRUITMENT_GUIDE_DOWNLOAD: "api/recruitment/recruitment-guide/download",
    RECRUITMENT_GUIDE_DELETE: "api/recruitment/recruitment-guide",
    // AI Features
    AI_JD_GENERATE: "api/ai-features/jd/generate",
    AI_JD_REGENERATE: "api/ai-features/jd/",
    AI_JD_SAVE: "api/ai-features/jd/save",
    AI_JD_GET: "api/ai-features/jd/",
    AI_JD_LIST: "api/ai-features/jd",
    AI_JD_DELETE: "api/ai-features/jd/",
    AI_CHATBOT_CHAT: "api/ai-features/chatbot/chat",
    AI_CHATBOT_HISTORY: "api/ai-features/chatbot/history",
    AI_CHATBOT_CLEAR: "api/ai-features/chatbot/history",
    // Organization Reports
    ORGANIZATION_REPORTS_GENERATE: "api/organization/reports/generate",
    ORGANIZATION_REPORTS_EXPORT_PDF: "api/organization/reports/export-pdf",
    ORGANIZATION_REPORTS_SCHEDULED: "api/organization/reports/scheduled",
    ORGANIZATION_REPORTS_SCHEDULED_DELETE_MANY: "api/organization/reports/scheduled/deleteMany",
    // Email Templates
    RECRUITMENT_EMAIL_TEMPLATES: "api/recruitment/email-templates",
    // Onboarding Checklist
    ONBOARDING_CHECKLIST: "api/recruitment/onboarding-checklist",
    ONBOARDING_CHECKLIST_ACCEPTED_OFFERS: "api/recruitment/onboarding-checklist/accepted-offers",
    // Checklist Templates
    CHECKLIST_TEMPLATES: "api/recruitment/checklist-templates",
    // Onboarding Tasks
    MY_TASKS: "api/recruitment/onboarding-tasks/my-tasks",
    REVIEWER_TASKS: "api/recruitment/onboarding-tasks/reviewer-tasks",
    // Background Verification
    BACKGROUND_VERIFICATION: "api/recruitment/background-verification",
    BACKGROUND_VERIFICATION_ELIGIBLE_APPLICATIONS: "api/recruitment/background-verification/eligible-applications",
    // LOI
    RECRUITMENT_LOI_DELETE_MANY: "api/recruitment/loi/deleteMany",
};